import type { Customer, CustomerFavorite } from '@barboxx/models/types';

import { api } from '../api';
import { throwIfBadResponse } from '../utils';

const rootPath = 'customers';

export function getCustomers(query: Customer.SearchQuery) {
    return api.get<Customer.SearchResponse>(rootPath, query);
}

export function getCustomer(id: number) {
    return api.get<Customer.WithSales>(`${rootPath}/${id}`);
}

export function updateCustomer(id: number, data: Customer.UpdateRequest) {
    return api.put<Customer>(`${rootPath}/${id}`, data);
}

export function updatePassword(data: Customer.UpdatePasswordRequest) {
    return api.put<Customer>(`${rootPath}/password`, data);
}

export function invalidateTokens() {
    return api.delete<{ message: string }>(`${rootPath}/tokens`);
}

export function deleteSelf(data: Customer.DeleteAccountRequest) {
    return api.delete<{ message: string }>(`${rootPath}`, undefined, {
        data: data,
    });
}

export function getSettings() {
    return api.get<Customer.Settings>(`${rootPath}/settings`);
}

export function getFavorites(query?: CustomerFavorite.SearchQuery) {
    return api.get<CustomerFavorite.SearchResponse>(
        `${rootPath}/favorites`,
        query
    );
}

export function addFavorite(data: CustomerFavorite.ToggleByMenuItemRequest) {
    return throwIfBadResponse(
        api.post<
            CustomerFavorite.ToggleByMenuItemRequest,
            CustomerFavorite.ToggleResponse
        >(`${rootPath}/favorites`, data)
    );
}

export function removeFavorite(menuItemId: number) {
    return throwIfBadResponse(
        api.delete<{ menuItemId: number }, CustomerFavorite.ToggleResponse>(
            `${rootPath}/favorites/${menuItemId}`
        )
    );
}

export function removeFavoriteByIdentity(data: CustomerFavorite.DeleteRequest) {
    return throwIfBadResponse(
        api.delete<
            CustomerFavorite.DeleteRequest,
            CustomerFavorite.ToggleResponse
        >(`${rootPath}/favorites`, data)
    );
}
